import React, { useState, useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router";
import { useCookies } from "react-cookie";

import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { doctorProfileFiles } from "../../Util/API Calls/APIList";
import afterLoginApiAxios from "../../Util/API Calls/afterLogin";
import SideDrawer from "../InstantConsultation/SideDrawer/SideDrawer_v2";
import PhysicalConsultationModal from "../PhysicalConsultation";
import EditProfile from "./edit-profile";
import SuccessProfileModal from "./SuccessProfileModal";
import DelayMarkingButton from "../DelayMarking/DelayMarkingButton";
import DelayMarkingModal from "../DelayMarking/DelayMarkingModal";
import AffectedAppointmentsPopup from "../DelayMarking/AffectedAppointmentsPopup";
import DelayMarkingAlertMsgPopup from "./DelayMarkingAlertMsgPopup";
import moment from "moment";
import { APIFILTERLIST } from "../DashboardAppointmentsView/Constant";
import { LOCALSTORAGEKEY } from "../../Util/Helper/localStorageUtils";
import { USER_ROLE } from "../../Util/constants";
import { C2CConsole } from "../../Util/Helper/C2CConsole";
import ReadMoreContent from "../common/ReadMoreComponent";
import AlertMsgPopup from "../common/AlertMsgPopup";

function DoctorProfile({
  parentCallback,
  nextAppointment,
  callNextAppointmentWidget,
}) {
  const history = useHistory();
  const [cookies] = useCookies(["cookie-name"]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [doctorFullName, setDoctorFullName] = useState("");
  const [showInstantConsult, setShowInstantConsult] = useState(false);
  const [showPhysicalConsultationModal, setShowPhysicalConsultationModal] =
    useState(false);
  const [appointmentType, setAppointmentType] = useState("");
  const [showEditProfileModal, setShowEditProfileModal] = useState(false);
  const [profile, setProfile] = useState({
    prefix_name: "",
    first_name: "",
    middle_name: "",
    last_name: "",
    display_name: "", // specialization
    degree: "",
    about: "",
    description: "",
    profile_picture_url: "",
    short_url_slug: "",
    is_partial_doctor: "False",
  });
  const [isUpdateProfile, setIsUpdateProfile] = useState(false);
  const [openDelayMarkingModal, setOpenDelayMarkingModal] = useState(false);
  const [openAffectedAppointments, setOpenAffectedAppointments] =
    useState(false);
  const [scheduleId, setScheduleId] = useState("");
  const [consultationType, setConsultationType] = useState("");
  const [openAlert, setOpenAlert] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [selectedConsultation, setSelectedConsultation] = useState(null);
  const [showMarkDelayBtn, setShowDelayMarkingBtn] = useState(false);
  const [showAlertPopup, setShowAlertPopup] = useState(false);
  const [alertMsgPop, setAlertMsgPop] = useState("");
  let firstName = doctorFullName?.split(" ").slice(0, 2).join(".");
  let lastName = doctorFullName?.split(" ").slice(2, 4).join(" ");

  const location = useLocation();
  const selectedDate = new URLSearchParams(location.search).get(
    APIFILTERLIST.STARTDATE
  );
  const clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);
  const prevConsultationType = useRef({});
  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  const doctorRole = localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_ROLE);

  useEffect(() => {
    getProfile();
  }, []);

  useEffect(() => {
    if (moment(selectedDate).isSameOrAfter(moment().format("YYYY-MM-DD"))) {
      checkDelayMarking();
    } else {
      setShowDelayMarkingBtn(false);
    }
  }, [clinicId, selectedDate]);

  const getProfile = () => {
    afterLoginApiAxios
      .post(
        "/doctor/get-doctor-profile", // Verify why two calls: get-doctor-details and get-my-profile???
        { doctor_id: userId ? userId : cookies?.user_id },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("id_token")
              ? localStorage.getItem("id_token")
              : cookies?.id_token,
          },
        }
      )
      .then((response) => {
        if (response && response?.data && response?.data?.statusCode === 200) {
          setProfile(response?.data?.doctor_profile_info);
          parentCallback(response?.data?.doctor_profile_info);
          localStorage.setItem(
            "doctorProfile",
            JSON.stringify(response.data.doctor_profile_info)
          );
          localStorage.setItem(
            "doctorName",
            response.data.doctor_profile_info?.prefix_name +
              " " +
              response.data.doctor_profile_info?.first_name +
              " " +
              response.data.doctor_profile_info?.middle_name +
              " " +
              response.data.doctor_profile_info?.last_name
          );
        }
      })
      .catch((err) => C2CConsole.log(err));
  };

  const checkDelayMarking = () => {
    afterLoginApiAxios
      .post(
        "/api/v1/doctor-schedules/get-procedure-list",
        {
          doctor_id: userId,
          date_selected: selectedDate,
          ...(clinicId && { clinic_id: clinicId }),
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("id_token")
              ? localStorage.getItem("id_token")
              : cookies?.id_token,
          },
        }
      )
      .then((response) => {
        if (response && response?.data && response?.data?.statusCode === 200) {
          if (response?.data?.procedure_list?.length > 0) {
            setShowDelayMarkingBtn(true);
          }
        } else {
          setShowDelayMarkingBtn(false);
          // TODO: Error handling and logging
        }
      })
      .catch((err) => C2CConsole.log(err));
  };
  useEffect(() => {
    let fullName =
      (profile?.prefix_name ? profile?.prefix_name : "") +
      (profile?.first_name ? " " + profile?.first_name : "") +
      (profile?.middle_name ? " " + profile?.middle_name : "") +
      (profile?.last_name ? " " + profile?.last_name : "");

    setDoctorFullName(fullName);
  }, [profile]);

  function handleBookingButtonClick(event) {
    if (doctorRole === USER_ROLE.RESOURCE_CONSULTANT) {
      handleInClinicModalShow();
    } else {
      setAnchorEl(event.currentTarget);
    }
  }

  function handleBookingMenuClose() {
    setAnchorEl(null);
  }

  function handleInstantConsultShow() {
    setShowInstantConsult(true);
  }

  function handleInstantConsultDrawerClose() {
    setShowInstantConsult(false);
  }

  function handleInClinicModalShow() {
    setShowPhysicalConsultationModal(true);
    setAppointmentType("in-clinic");
  }

  function handleOnlineModalShow() {
    setShowPhysicalConsultationModal(true);
    setAppointmentType("online");
  }

  const showSetAppointmentType = (onlineAppointment) => {
    setShowAlertPopup(true);
    setTimeout(() => {
      setShowAlertPopup(false);
    }, 2000);
    if (onlineAppointment) {
      setAlertMsgPop("Link Shared Successfully");
    } else {
      setAlertMsgPop("Appointment Booked Successfully");
    }
  };

  function handleEditProfileShow() {
    setShowEditProfileModal(true);
  }

  function handleEditProfileClose(message) {
    setShowEditProfileModal(false);
    if (message === "updateSuccess") {
      setIsUpdateProfile(true);
      getProfile();
      setTimeout(() => {
        setIsUpdateProfile(false);
      }, 2000);
    }
  }

  // Actions ===>

  const handleDelayMarkingBtn = () => {
    setSelectedConsultation(null);
    setOpenDelayMarkingModal(true);
  };

  const handleConsultationDropDown = (option) => {
    if (prevConsultationType.current?.value !== option?.value) {
      localStorage.removeItem("delayMarkingSlotsList");
    }
    setSelectedConsultation(option);
    prevConsultationType.current = option;
  };

  const handleReviewChanges = (id) => {
    setScheduleId(id);
    setConsultationType(selectedConsultation?.label);
    setOpenDelayMarkingModal(false);
    setOpenAffectedAppointments(true);
  };

  const handleClosePopup = () => {
    localStorage.removeItem("delayMarkingSlotsList");
    setOpenAffectedAppointments(false);
  };

  const handleOpenPrevPopop = () => {
    setOpenAffectedAppointments(false);
    setOpenDelayMarkingModal(true);
  };

  const handleMarkDelaySuccess = () => {
    localStorage.removeItem("delayMarkingSlotsList");
    handleOpenPrevPopop();
    setOpenAlert(true);
    setAlertMsg(
      <span>
        Mark Delay is Successful for <b>{localStorage.getItem("doctorName")}</b>
      </span>
    );
    setTimeout(() => {
      setOpenAlert(false);
    }, 2000);
  };

  const handleClose = () => {
    localStorage.removeItem("delayMarkingSlotsList");
    setOpenDelayMarkingModal(false);
  };

  // <===

  return (
    <div className="dashboard-profile">
      {profile?.is_partial_doctor !== undefined &&
      profile?.is_partial_doctor.toLowerCase() === "false" &&
      profile?.profile_picture_url !== "" ? (
        <div className="d-flex justify-content-center">
          <img
            className="rounded-circle profile_pic_style"
            alt="Doctor Profile"
            src={doctorProfileFiles + profile?.profile_picture_url}
          />
        </div>
      ) : (
        <div className="d-flex justify-content-center">
          <div className="profile-image-placeholder rounded-circle d-flex justify-content-center align-items-center">
            <span>
              {profile?.first_name &&
                profile?.first_name.charAt(0) + " " + profile?.last_name &&
                profile?.last_name.charAt(0)}
            </span>
          </div>
        </div>
      )}
      <div className="text-center mt-3 mb-4">
        <div
          className="mb-2"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <h3 className="m-0 doctor-name" style={{ maxWidth: "160px" }}>
            {doctorRole !== USER_ROLE.RESOURCE_CONSULTANT
              ? firstName + " " + lastName
              : profile.first_name +
                " " +
                (profile.middle_name && profile.middle_name + " ") +
                profile.last_name}
          </h3>
          {profile?.is_partial_doctor.toLowerCase() === "false" &&
          doctorRole !== USER_ROLE.RESOURCE_CONSULTANT ? (
            <h3
              className="m-0 ml-3"
              data-tooltip="Edit Profile"
              data-tooltip-conf="top"
            >
              <a
                className="primary cursor-pointer"
                onClick={handleEditProfileShow}
              >
                <i className="fa fa-pencil-square-o"></i>
              </a>
            </h3>
          ) : (
            ""
          )}
        </div>
        <h4 className="text-capitalize">{profile?.display_name}</h4>
      </div>
      {profile?.is_partial_doctor.toLowerCase() === "false" ? (
        <div className="row mb-3">
          <div className="col-12 d-lg-flex d-flex justify-content-center">
            <button
              className="btn btn-sm primary-cta-button rounded-pill py-2 px-3"
              aria-controls="booking-menu"
              aria-haspopup="true"
              onClick={handleBookingButtonClick}
            >
              {localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_ROLE) ===
              USER_ROLE.RESOURCE_CONSULTANT
                ? "Book Procedure"
                : "Book Appointment"}
            </button>
            <Menu
              id="booking-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleBookingMenuClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "center",
              }}
              className="li_style"
            >
              <MenuItem
                onClick={() => {
                  handleBookingMenuClose();
                  handleInstantConsultShow();
                }}
              >
                <p className={"font-weight-bold border_style m-0"}>
                  Instant Consultation
                </p>
              </MenuItem>
              <MenuItem
                onClick={() => {
                  handleBookingMenuClose();
                  handleInClinicModalShow();
                }}
              >
                <p className={"font-weight-bold m-0"}>In-Clinic Consultation</p>
              </MenuItem>
              <MenuItem
                onClick={() => {
                  handleBookingMenuClose();
                  handleOnlineModalShow();
                }}
              >
                <p className={"font-weight-bold m-0"}>Online Consultation</p>
              </MenuItem>
            </Menu>
            {showMarkDelayBtn && (
              <div className=" px-sm-2 px-lg-2 px-3">
                <DelayMarkingButton handleClick={handleDelayMarkingBtn} />
              </div>
            )}
          </div>
        </div>
      ) : (
        ""
      )}
      {profile?.degree && (
        <div className="row mb-3 px-4 px-lg-0 degree-text-overflow">
          <div className="col-2">
            <i className="fa fa-graduation-cap fa-lg secondary"></i>
          </div>
          <div className="col-10">
            <p style={{ fontSize: "1rem" }}>{profile?.degree}</p>
          </div>
        </div>
      )}

      {profile?.about && (
        <div className="row mb-3 px-4 px-lg-0">
          <div className="col-2">
            <i className="fa fa-hospital-o fa-lg secondary"></i>
          </div>
          <div className="col-10">
            <p style={{ fontSize: "1rem" }}>{profile?.about}</p>
          </div>
        </div>
      )}

      {profile?.description && (
        <div className="row px-4 px-lg-0">
          <div className="col-2">
            <i className="fa fa-commenting fa-lg secondary"></i>
          </div>
          <div className="col-10 mb-3">
            <ReadMoreContent
              text={profile?.description}
              title1={"Read More"}
              title2={"Read Less"}
              truncatedEndingComponent={"... "}
              lines={15}
            />
          </div>
        </div>
      )}

      {showInstantConsult && (
        <SideDrawer
          className="side_drawer_main"
          open={showInstantConsult}
          slugUrl={profile?.short_url_slug}
          doctorName={doctorFullName}
          nextAppointment={nextAppointment}
          closeDrawerCallback={handleInstantConsultDrawerClose}
          history={history}
        />
      )}
      {showPhysicalConsultationModal ? (
        <div style={{ border: "5px solid" }}>
          <PhysicalConsultationModal
            appointmentType={appointmentType}
            doctor_slug={profile?.short_url_slug}
            closeView={() => {
              setShowPhysicalConsultationModal(false);
            }}
            openView={showPhysicalConsultationModal}
            isAddMode={true}
            step={1}
            doctorData={{
              common_procedure: profile?.common_procedure === "True",
            }}
            callNextAppointmentWidget={callNextAppointmentWidget}
            handleSetAppointmentType={showSetAppointmentType}
          />
        </div>
      ) : (
        ""
      )}
      {showEditProfileModal ? (
        <EditProfile
          openView={showEditProfileModal}
          id="doctor_edit_profile"
          closeView={handleEditProfileClose}
        />
      ) : (
        ""
      )}
      {isUpdateProfile && <SuccessProfileModal show={isUpdateProfile} />}
      {showAlertPopup && <AlertMsgPopup alertMsg={alertMsgPop} />}
      {openDelayMarkingModal && (
        <DelayMarkingModal
          open={openDelayMarkingModal}
          selectedConsultation={selectedConsultation}
          handleClose={handleClose}
          handleReviewChanges={handleReviewChanges}
          handleConsultationDropDown={handleConsultationDropDown}
          doctorName={localStorage.getItem("doctorName")}
          doctorId={userId}
        />
      )}
      {openAffectedAppointments && (
        <AffectedAppointmentsPopup
          openPopup={openAffectedAppointments}
          scheduleId={scheduleId}
          consultationType={consultationType}
          handleClosePopup={handleClosePopup}
          handleOpenPrevPopop={handleOpenPrevPopop}
          handleMarkDelaySuccess={handleMarkDelaySuccess}
        />
      )}
      {openAlert && <DelayMarkingAlertMsgPopup alertMsg={alertMsg} />}
    </div>
  );
}

export default DoctorProfile;
